import { ILocale } from '@dash/country';
import libsLocales from './libsLocales';

const { antd } = libsLocales;

export const languages: { [key: string]: ILocale } = {
  en_US: 'en-US',
  en_GB: 'en-GB',
  en_AU: 'en-AU',
  he_IL: 'he-IL',
};

export const languagesConfig = {
  [languages.en_US]: {
    name: 'English',
    locales: {
      app: languages.en_US,
      antd: antd.en_US,
    },
    icon: null,
  },
  [languages.en_AU]: {
    name: 'English (Australia)',
    locales: {
      app: languages.en_AU,
      antd: antd.en_AU,
    },
    icon: null,
  },
  [languages.he_IL]: {
    name: 'Hebrew',
    locales: {
      app: languages.he_IL,
      antd: antd.he_IL,
    },
    icon: null,
  },
  [languages.en_GB]: {
    name: 'English',
    locales: {
      app: languages.en_GB,
      antd: antd.en_GB,
    },
    icon: null,
  },
};
